import { Typography, Button, Box, Grid, Container } from "@mui/material";
import { useEffect } from "react";

const C = {
  black: "#111111",
  cream: "#F8F5FF",
  green: "#7B2FBE",
  greenLight: "#9644D8",
  gold: "#00D4E8",
  white: "#ffffff",
  grey: "#6B6B6B",
  border: "#E0D5F5",
};
const dmSans = "'DM Sans', sans-serif";
const playfair = "'Playfair Display', serif";

const MockRow = ({ emoji, text }) => (
  <Box sx={{ display: "flex", gap: "6px", alignItems: "baseline", my: "4px" }}>
    <span style={{ fontSize: "0.85rem" }}>{emoji}</span>
    <Typography
      sx={{
        fontSize: "0.875rem",
        color: "rgba(255,255,255,0.85)",
        fontFamily: dmSans,
      }}
    >
      {text}
    </Typography>
  </Box>
);

export const FormPage = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://tally.so/widgets/embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script); // Clean up the script when the component unmounts
    };
  }, []);
  return (
    <>
          <Box
            component="nav"
            sx={{
              position: "fixed", top: 0, left: 0, right: 0, zIndex: 100,
              display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: { xs: "14px 20px", md: "16px 48px" },
              background: "rgba(248,245,255,0.95)",
              backdropFilter: "blur(12px)",
              borderBottom: `1px solid ${C.border}`,
              gap: 2,
            }}
          >
            {/* Logo */}
            <Box
              component="a"
              href="/"
              sx={{
                fontFamily: playfair, fontSize: "1.4rem", fontWeight: 900,
                color: C.green, letterSpacing: "-0.02em",
                textDecoration: "none", flexShrink: 0,
              }}
            >
              <img
                src="/logo_1.png"
                alt="Logo"
                style={{ height: "30px", verticalAlign: "middle" }}
              />
            </Box>
            </Box>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: "300px", sm: "300px", md: "250px" }, // Responsive height
          background: "linear-gradient(to right, #6B0AC9, #36EAEF )",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          textAlign: "center",
          objectPosition: "center bottom", // ⬅️ try 'center top', 'center center', or 'center bottom'
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            // backgroundColor: "rgba(0, 0, 0, 0.4)", // Semi-transparent black shadow
            zIndex: 1,
          }}
        >
          <Box
            sx={{
              padding: "16px",
              paddingTop: { xs: "120px", sm: "100px", md: "100px" }, // Increased padding for more space
              borderRadius: "8px",
            }}
          >
            <Typography
              variant="h3"
              fontWeight="bold"
              gutterBottom
              sx={{ fontSize: { xs: "2rem", sm: "3rem" } }}
            >
              Explica’ns què busques i t’ho trobem.
            </Typography>
            <Typography
              variant="h6"
              fontWeight="bold"
              gutterBottom
              sx={{
                fontSize: { xs: "1.2rem", sm: "1.2rem" },
                color: "orange",
              }}
            >
              (Servei exclusiu per a pisos de compravenda)
            </Typography>
          </Box>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid container spacing={2} sx={{ width: 1 }}>
          <Grid size={{ xs: 12, md: 12, lg: 8 }} offset={{ lg: 2 }}>
            <Box textAlign="center" mb={6}>
              <iframe
                src="https://tally.so/embed/3xzADJ?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
                loading="lazy"
                width="100%"
                height="100%"
                frameBorder={0}
                marginHeight={0}
                marginWidth={0}
                title="Busco pis a Andorra"
              ></iframe>
            </Box>
            <Box
              id="canal"
              component="section"
              sx={{
                background: C.black,
                padding: { xs: "70px 24px", md: "100px 48px" },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                  color: C.gold,
                  mb: "20px",
                  fontFamily: dmSans,
                }}
              >
                Canal de propietats
              </Typography>

              <Typography
                component="h2"
                sx={{
                  fontFamily: playfair,
                  fontSize: "clamp(2rem, 3.5vw, 3rem)",
                  fontWeight: 900,
                  color: C.white,
                  textAlign: "center",
                  maxWidth: 680,
                  letterSpacing: "-0.02em",
                  lineHeight: 1.1,
                  mb: 2,
                  "& em": { fontStyle: "italic", color: C.gold },
                }}
                dangerouslySetInnerHTML={{ __html: "Rep propietats seleccionades sense buscar res" }}
              />

              <Typography
                sx={{
                  color: "rgba(255,255,255,0.5)",
                  textAlign: "center",
                  maxWidth: 520,
                  fontSize: "1rem",
                  lineHeight: 1.7,
                  fontWeight: 300,
                  mb: 6,
                  fontFamily: dmSans,
                }}
              >
              Publiquem propietats que realment valen la pena. Si t'interessa, ens escrius amb el codi.
              </Typography>

              {/* Mock post */}
              <Box
                sx={{
                  background: "#1E1E1E",
                  border: "1px solid #2E2E2E",
                  borderRadius: "20px",
                  padding: "32px",
                  maxWidth: 420,
                  width: "100%",
                  mb: 5,
                }}
              >
                {/* Header del post */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    mb: "20px",
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, #00D4E8, #7B2FBE)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1rem",
                      flexShrink: 0,
                    }}
                  >
                    🏠
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "0.875rem",
                        fontWeight: 600,
                        color: C.white,
                        fontFamily: dmSans,
                      }}
                    >
                      Buscopis · Canal
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "rgba(255,255,255,0.4)",
                        fontFamily: dmSans,
                      }}
                    >
                      avui, 10:23
                    </Typography>
                  </Box>
                </Box>

                {/* Contingut del post */}
                <Typography
                  sx={{
                    fontSize: "0.95rem",
                    fontWeight: 700,
                    color: C.white,
                    mb: 2,
                    fontFamily: dmSans,
                  }}
                >
                  📍 Pis al centre d'Escaldes
                </Typography>

                <MockRow emoji="🏠" text="→ 70 m²" />
                <MockRow emoji="🛏️" text="→ 2 habitacions" />
                <MockRow emoji="🌱" text="→ Balcó" />
                <MockRow emoji="☀️" text="→ Orientació sud" />
                <MockRow emoji="🛀" text="→ 2 banys" />
                <MockRow emoji="🚗" text="→ 1 plaça d'aparcament" />
                <MockRow emoji="🙅" text="→ Sense llogaters" />
                <MockRow emoji="💰" text="→ Entre 500.000 € i 550.000 €" />

                {/* Codi */}
                <Box
                  sx={{
                    mt: "20px",
                    pt: "20px",
                    borderTop: "1px solid #2E2E2E",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      fontFamily: "monospace",
                      fontSize: "0.8rem",
                      color: C.gold,
                      background: "rgba(0,212,232,0.12)",
                      padding: "4px 10px",
                      borderRadius: "6px",
                    }}
                  >
                    ESCALDES1
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "0.75rem",
                      color: "rgba(255,255,255,0.4)",
                      fontFamily: dmSans,
                    }}
                  >
                    📩 Escriu-nos amb el codi
                  </Typography>
                </Box>
              </Box>

              {/* Botons de canal */}
              <Box
                sx={{
                  display: "flex",
                  gap: "12px",
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}
              >
                <Box
                  component="a"
                  href="https://whatsapp.com/channel/0029VbC42mkFnSz1HWHLiX0h"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    background: "#25D366",
                    color: C.white,
                    borderRadius: "12px",
                    padding: "14px 24px",
                    fontSize: "0.95rem",
                    fontWeight: 500,
                    textDecoration: "none",
                    fontFamily: dmSans,
                    transition: "all 0.2s",
                    "&:hover": {
                      filter: "brightness(1.1)",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  <span>📱</span>
                  <span>Canal de WhatsApp</span>
                </Box>

                <Box
                  component="a"
                  href="https://t.me/buscopis"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    background: "#229ED9",
                    color: C.white,
                    borderRadius: "12px",
                    padding: "14px 24px",
                    fontSize: "0.95rem",
                    fontWeight: 500,
                    textDecoration: "none",
                    fontFamily: dmSans,
                    transition: "all 0.2s",
                    "&:hover": {
                      filter: "brightness(1.1)",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  <span>✈️</span>
                  <span>Canal de Telegram</span>
                </Box>
              </Box>
            </Box>
            <br />
            <br />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
